"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelect = void 0;
const react_1 = __importStar(require("react"));
const form_select_1 = require("../../../composite/form/fields/form-select");
function useSelect({ dataHook, multiple = false, }) {
    const Cell = (0, react_1.useMemo)(() => function SelectCell(props) {
        const source = dataHook();
        return (react_1.default.createElement(form_select_1.FormSelect, { ...props, source: source, valueIsId: true, multiple: multiple }));
    }, [dataHook, multiple]);
    return Cell;
}
exports.useSelect = useSelect;
//# sourceMappingURL=select.js.map